import { Injectable, Injector, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { catchError, finalize, map, Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from '../../shared/services/api-service';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(private _api: ApiService) {}

  async getCompanies(): Promise<any> {
    return await this._api
      .getMethodsWithoutTokenAndParams('/api/Company/GetCompanies')
      .then((res) => {
        return res;
      });
  }

  async setCurrentProject(projectId: number | undefined): Promise<any> {
    let params = new HttpParams().set(
      'projectId',
      projectId?.toString() as any
    );

    return await this._api
      .getMethodsWithParams('/auth/SetCurrentProject', params)
      .then((res) => {
        return res;
      });
  }
}
